import parseImageData from './parseImageData';

const buildImageGroups = (images, priorityLimit, shouldDisplayCaption) => {
  const imageGroups = [];
  let imageGroupIndex = 0;
  const isDivisible = images.length % 3 === 0;

  images.forEach((image, index) => {
    if (!imageGroups[imageGroupIndex])
      imageGroups[imageGroupIndex] = [
        parseImageData(image, index, priorityLimit, shouldDisplayCaption)
      ];
    else
      imageGroups[imageGroupIndex].push(
        parseImageData(image, index, priorityLimit, shouldDisplayCaption)
      );

    if (isDivisible) {
      if (imageGroups[imageGroupIndex].length >= 3) imageGroupIndex += 1;
    } else {
      if (imageGroupIndex === 0 && imageGroups[imageGroupIndex].length >= 2) {
        imageGroupIndex += 1;
        return;
      }
      if (imageGroups[imageGroupIndex].length >= 3) imageGroupIndex += 1;
    }
  });

  return imageGroups;
};

const separateImages = (images, priorityLimit, shouldDisplayCaption) => {
  if (!images || !images.length) return [];

  return buildImageGroups(images, priorityLimit, shouldDisplayCaption);
};

export default separateImages;
